import Vue from 'vue'
import service from '../services/warehouseClientsService.js'

export function useClients() {
  const state = Vue.observable({
    items: [],
    currentPage: 1,
    lastPage: 1,
    loading: false
  })

  async function getClients(params = {}) {
    state.loading = true
    try {
      const response = await service.getClients(params)

      const data = response.data.map(el => ({
        ...el,
        gracePeriod: el.days / 24,
      }))
      state.items = response.current_page === 1
        ? [...data]
        : [...state.items, ...data]
      state.currentPage = response.current_page
      state.lastPage = response.last_page
      state.loading = false
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  async function updateGracePeriod(payload) {
     state.loading = true
     try {
       const response = await service.updateGracePeriod(payload)
       return { success: true, response }
     } catch (err) {
       return { success: false, error: err }
     } finally {
       state.loading = false
     }
   }

  return { state, getClients, updateGracePeriod }
}
